import { Dropdown } from 'module/ui/components/atoms/dropdown/dropdown';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { CenterAlignedBox } from 'module/ui/components/atoms/layout/layout';
import {
  faBookSparkles,
  faGlobe,
  faLink,
  faPaperclip,
} from '@fortawesome/pro-regular-svg-icons';
import { faChevronDown, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { Icon } from '@rocketlane/ui';
import { Button } from '@rocketlane/ui';
import { FormattedMessage } from 'react-intl';

export enum AddKnowledgeTriggerType {
  Files = 'files',
  ImportWebsite = 'import-website',
  ApiDoc = 'api-doc',
  AiPages = 'ai-pages',
}
type Props = {
  onSelect?: (type: AddKnowledgeTriggerType) => void;
};
export const AddKnowledgeTrigger = ({ onSelect }: Props) => {
  return (
    <Dropdown
      menu={{
        onClick: (e) => {
          onSelect?.(e.key as AddKnowledgeTriggerType);
        },
        items: [
          {
            label: (
              <FormattedMessage id="knowledge_base.add_knowledge.ai_pages.label" />
            ),
            key: AddKnowledgeTriggerType.AiPages,
            icon: <Icon icon={faBookSparkles} size=".75x" />,
          },
          {
            label: (
              <FormattedMessage id="knowledge_base.add_knowledge.api_doc.label" />
            ),
            key: AddKnowledgeTriggerType.ApiDoc,
            icon: <Icon icon={faLink} size=".75x" />,
          },
          {
            label: (
              <FormattedMessage id="knowledge_base.add_knowledge.import_website.label" />
            ),
            key: AddKnowledgeTriggerType.ImportWebsite,
            icon: <Icon icon={faGlobe} size=".75x" />,
          },
          {
            label: (
              <FormattedMessage id="knowledge_base.add_knowledge.files.label" />
            ),
            key: AddKnowledgeTriggerType.Files,
            icon: <Icon icon={faPaperclip} size=".75x" />,
          },
        ],
      }}
    >
      <Button
        variant="primary"
        rightIcon={<FontAwesomeIcon icon={faChevronDown} size={12} />}
      >
        <CenterAlignedBox className="whitespace-nowrap">
          <FontAwesomeIcon icon={faPlus} size={12} />
          <FormattedMessage id="knowledge_base.add_knowledge.trigger.label" />
        </CenterAlignedBox>
      </Button>
    </Dropdown>
  );
};
